import {
  useQueryClient,
  useQuery,
  useMutation,
  keepPreviousData,
} from "@tanstack/react-query";
import { errorMessage, successMessage } from "../../../utils/helper";
import {
  getFinishedProductsList,
  updatePOSSyncApi,
  changeDefaultStatusApi,
} from "../api/PosSyncApi";
import qs from "qs";

const finishedProductsWithoutPLUKeys = {
  all: ["finishedProductsWithoutPlu"],
  lists: () => [...finishedProductsWithoutPLUKeys.all, "lists"],
  productslist: (filters) => [
    ...finishedProductsWithoutPLUKeys.lists(),
    filters,
  ],
};

export const useFinishedProductsListQueries = ({
  selectedCategory,
  selectedType,
  selectedStatus,
  selectedSubCategory,
  debouncedText,
  sorting,
  pagination,
}) => {
  const queryClient = useQueryClient();
  let params = {};

  if (selectedCategory?.length > 0) {
    params = {
      ...params,
      category_id: selectedCategory?.map((item) => item.id),
    };
  }
  if (selectedSubCategory?.length > 0) {
    params = {
      ...params,
      subcategory_id: selectedSubCategory?.map((item) => item.id),
    };
  }
  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }

  if (selectedType !== "") {
    params = { ...params, type: selectedType };
  }
  if (selectedStatus !== "") {
    params = { ...params, status: selectedStatus };
  }
  if (sorting?.length > 0) {
    const sortByParams = sorting.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
      {},
    );
    params = {
      ...params,
      sort: sortByParams,
    };
  }
  params = { ...params, has_plu: 1 };

  const query = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  };

  //list useQueryClient
  const listQuery = useQuery({
    queryKey: finishedProductsWithoutPLUKeys.productslist({
      query,
      pagination,
    }),
    queryFn: () => getFinishedProductsList({ query, pagination }),
    placeholderData: keepPreviousData,
    enabled: true,
  });

  const updatePOSSync = useMutation({
    mutationFn: updatePOSSyncApi,
    onSuccess: ({ success, message }) => {
      success ? successMessage(message) : errorMessage(message);
      queryClient.invalidateQueries({
        queryKey: finishedProductsWithoutPLUKeys.lists(),
      });
    },
    onError: (error) =>
      errorMessage(
        error.response.data?.message || "Scheduled sync update failed",
      ),
  });

  const changeDefaultStatus = useMutation({
    mutationFn: changeDefaultStatusApi,
    onSuccess: ({ success, message }) => {
      success ? successMessage(message) : errorMessage(message);
      queryClient.invalidateQueries({
        queryKey: finishedProductsWithoutPLUKeys.lists(),
      });
    },
    onError: (error) =>
      errorMessage(
        error.response.data?.message || "Scheduled sync update failed",
      ),
  });

  return {
    listQuery,
    updatePOSSync,
    changeDefaultStatus,
  };
};
